import { Button, Stack } from '@mui/material';

import { ExternalLink, NotableMarkdown, isDefined } from 'common';

import { documentationLinkByBlockType } from './utils';
import { type UiBlockType } from '../../../../ReactFlow/types';

interface DocumentationWithExternalLinkProps {
  blockType: UiBlockType;
  documentationMarkdown: string;
}

export function DocumentationWithExternalLink(props: DocumentationWithExternalLinkProps) {
  const { blockType, documentationMarkdown } = props;
  return (
    <Stack gap={2}>
      {isDefined(documentationLinkByBlockType[blockType]) && (
        <Button
          variant="outlined"
          component={ExternalLink}
          href={documentationLinkByBlockType[blockType]}
          sx={{ alignSelf: 'flex-start' }}
        >
          View Documentation in New Window
        </Button>
      )}
      <NotableMarkdown>{documentationMarkdown}</NotableMarkdown>
    </Stack>
  );
}
